/* eslint-disable */
import React from "react";

/**
 * Skeleton for the member-360 panel: identity row, the four-figure totals
 * strip, the tab bar and a list of rows. Uses the global `.gskel` shimmer
 * (transform-based, so it keeps animating while the main thread is busy) —
 * same primitive PageSkeleton and DashboardListSkeleton use.
 *
 * `compact` matches the narrow panel rendered beside a ticket thread.
 */
function MemberProfileSkeleton({ rows = 6, compact = false }) {
  return (
    <div
      className="bg-white dark:bg-gray-800 rounded-2xl border border-slate-200 dark:border-gray-700 overflow-hidden"
      aria-busy="true"
      aria-label="Loading member profile"
    >
      {/* Identity */}
      <div className="p-4 border-b border-slate-100 dark:border-gray-700">
        <div className="flex items-center gap-3">
          <span className="gskel" style={{ width: 44, height: 44, borderRadius: "9999px" }} />
          <div className="flex-1 space-y-2">
            <span className="gskel" style={{ display: "block", height: 12, width: "45%", borderRadius: 6 }} />
            <span className="gskel" style={{ display: "block", height: 10, width: "65%", borderRadius: 6 }} />
          </div>
        </div>

        {/* Totals strip */}
        <div className={`grid ${compact ? "grid-cols-2" : "grid-cols-4"} gap-2 mt-3`}>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="px-3 py-2 rounded-lg bg-slate-50 dark:bg-gray-900/40 space-y-2">
              <span className="gskel" style={{ display: "block", height: 8, width: "70%", borderRadius: 4 }} />
              <span className="gskel" style={{ display: "block", height: 12, width: "85%", borderRadius: 4 }} />
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div className="flex items-center gap-4 px-4 py-3 border-b border-slate-100 dark:border-gray-700">
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i} className="gskel" style={{ height: 10, width: 58, borderRadius: 6 }} />
        ))}
      </div>

      {/* Rows */}
      <div className="px-4 divide-y divide-slate-100 dark:divide-gray-700">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="py-3 flex items-center gap-3">
            <div className="flex-1 space-y-2">
              <span className="gskel" style={{ display: "block", height: 11, width: "40%", borderRadius: 6 }} />
              <span className="gskel" style={{ display: "block", height: 9, width: "60%", borderRadius: 6 }} />
            </div>
            <span className="gskel" style={{ height: 18, width: 64, borderRadius: 9999 }} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default MemberProfileSkeleton;
